export default __webpack_public_path__ + "static/lframe-financial-hardship-624edd841647e96226a6d800596f4843.png";